import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function WebDesign() {
useEffect(() => {
AOS.init({ duration: 1000, once: true });
}, []);

    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Web Design</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Web Design Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Web Design Services</h2>
                        <p className="section-description">
                            We specialize in responsive design, engaging user experiences, SEO-friendly layouts, and visually stunning interfaces using tools like React, Vue, and Angular.
                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Responsive Design</h3>
                            <p>We deliver websites designed to adapt flawlessly across all screen sizes, providing a smooth browsing experience whether on a phone, tablet, or desktop.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-paint-brush"></i>
                            </div>
                            <h3>Creative UI/UX</h3>
                            <p>Our designs are built with a focus on the user, offering clean navigation, smooth interactions, and a natural flow that keeps visitors engaged from start to finish.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-film"></i>
                            </div>
                            <h3>Visual Storytelling</h3>
                            <p>Graphics, animations, and motion effects are thoughtfully used to tell a brand’s story, adding depth and personality that help create stronger connections with audiences..</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Design Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header"  data-aos="fade-left" data-aos-delay="200">
                        <h2>Our Design Process</h2>
                        <p className="section-description">
                            A structured, transparent process for designing user-first websites that deliver results.
                        </p>
                    </div>

                    <div className="process-timeline"   data-aos="fade-left" data-aos-delay="300">
                        <div className="process-step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Planning</h3>
                                <p>We begin by setting clear goals, understanding the audience, and defining the vision for the website.</p>
                            </div>
                        </div>

                        <div className="process-step"  data-aos="fade-left"  data-aos-delay="300">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Site Architecture</h3>
                                <p>A well-structured site map and organized content layout are created to guide users effortlessly through the site.</p>
                            </div>
                        </div>

                        <div className="process-step"  data-aos="fade-left"  data-aos-delay="300">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Creation (Design & Development)</h3>
                                <p>Visual mockups, typography, color schemes, and imagery are designed, followed by interactive front-end development.</p>
                            </div>
                        </div>

                        <div className="process-step"  data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Testing</h3>
                                <p>Rigorous testing is done to ensure the design works seamlessly on different devices and browsers, fixing issues early.</p>
                            </div>
                        </div>

                        <div className="process-step"  data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Launching</h3>
                                <p>The website is launched with domain setup and server deployment, ensuring everything is polished and ready for visitors.</p>
                            </div>
                        </div>

                        <div className="process-step"  data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Maintenance</h3>
                                <p>Continuous care is provided through updates, security checks, and performance improvements, helping your website grow and stay relevant.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="why-choose-section mt-2" >
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our Web Design?</h2>
                    </div>

                    <div className="features-grid" data-aos="fade-left" data-aos-delay="300">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-palette"></i>
                            </div>
                            <h3>Consistent Branding</h3>
                            <p>We focus on maintaining a strong and recognizable brand presence by carefully selecting colors, fonts, and visual elements that reflect your identity..</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-object-group"></i>
                            </div>
                            <h3>Unique Visual Elements</h3>
                            <p>Customized illustrations and unique graphics make each project stand out, while engaging content and multimedia features create a more dynamic and memorable experience</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-file-alt"></i>
                            </div>
                            <h3>Engaging Content</h3>
                            <p>Strategic calls to action are placed to encourage users to connect, inquire, or explore more of what you offer.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-bullhorn"></i>
                            </div>
                            <h3>Clear Call to Action</h3>
                            <p>We also seamlessly integrate social media connections, bridging your website with the platforms your audience uses most.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-tablet-alt"></i>
                            </div>
                            <h3>Responsive & Mobile-Friendly</h3>
                            <p>Every design is built with adaptability and long-term performance in mind, so your online presence feels modern, engaging, and ready to deliver results.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-share-alt"></i>
                            </div>
                            <h3>Social Media Integration</h3>
                            <p>Embed social links and sharing features to connect your website with popular platforms.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technology Stack Section */}
            

            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Start Your Web Project?</h2>
                        <p>Let's create a stunning website that drives results for your business.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default WebDesign;
